import { ASSESSMENT_TEMPLATE_LIST, AUDIT_LOGS, CHATTER_CLIENT_LIST, CHATTER_LESSON_LIST, CHATTER_PEER_LIST, CHATTER_PROGRAM_LIST, CHATTER_TEMPLATE_LIST, CLASSROOM_CONSULTATIONS, DESIGNATIONS_LIST, DISCHARGES, DISCIPLINES_LIST, FUNDING_SOURCE_LIST, GOALS_LIST, HOME_EDUCATION_LIST, MANAGE_CMS_LIST, MANAGE_CONSENT_FORM, MANAGE_EXPORT, MANAGE_NOTIFICATION_EMAIL_TEMPLATE_LIST, MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_LIST, MANAGE_PARENTS_LIST, MANAGE_STATUS_LIST, MANAGE_SUPPORT_STAFF_LIST, MANAGE_TEACHERS_LIST, MANAGE_USERS_LIST, MDT_ASSESSMENT_LIST, MDT_STATUS_LIST, MDT_TERMS_LIST, NOTES_TABLE, POLICY_AND_PROCEDURE, PRIVATE_CLIENT_LIST, SCHOOL_CLIENT_LIST, SCHOOL_DIVISON_LIST, SCHOOL_LIST, SERVICE_STATUS_LIST, THERAPIST_LIST, WORKSHOPS } from "./paths";

const moduleConfig = [
  {
    label: "Clients",
    icon: <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
    >
      <mask
        id="mask0_1_3245"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="-1"
        y="-2"
        width="24"
        height="25"
      >
        <rect
          x="-1"
          y="-1.49707"
          width="24"
          height="24"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_1_3245)">
        <path
          d="M0 18.5029V15.7029C0 15.1363 0.145833 14.6154 0.4375 14.1404C0.729167 13.6654 1.11667 13.3029 1.6 13.0529C2.63333 12.5363 3.68333 12.1488 4.75 11.8904C5.81667 11.6321 6.9 11.5029 8 11.5029C9.1 11.5029 10.1833 11.6321 11.25 11.8904C12.3167 12.1488 13.3667 12.5363 14.4 13.0529C14.8833 13.3029 15.2708 13.6654 15.5625 14.1404C15.8542 14.6154 16 15.1363 16 15.7029V18.5029H0ZM18 18.5029V15.5029C18 14.7696 17.7958 14.0654 17.3875 13.3904C16.9792 12.7154 16.4 12.1363 15.65 11.6529C16.5 11.7529 17.3 11.9238 18.05 12.1654C18.8 12.4071 19.5 12.7029 20.15 13.0529C20.75 13.3863 21.2083 13.7571 21.525 14.1654C21.8417 14.5738 22 15.0196 22 15.5029V18.5029H18ZM8 10.5029C6.9 10.5029 5.95833 10.1113 5.175 9.32793C4.39167 8.5446 4 7.60293 4 6.50293C4 5.40293 4.39167 4.46126 5.175 3.67793C5.95833 2.8946 6.9 2.50293 8 2.50293C9.1 2.50293 10.0417 2.8946 10.825 3.67793C11.6083 4.46126 12 5.40293 12 6.50293C12 7.60293 11.6083 8.5446 10.825 9.32793C10.0417 10.1113 9.1 10.5029 8 10.5029ZM18 6.50293C18 7.60293 17.6083 8.5446 16.825 9.32793C16.0417 10.1113 15.1 10.5029 14 10.5029C13.8167 10.5029 13.5833 10.4821 13.3 10.4404C13.0167 10.3988 12.7833 10.3529 12.6 10.3029C13.05 9.7696 13.3958 9.17793 13.6375 8.52793C13.8792 7.87793 14 7.20293 14 6.50293C14 5.80293 13.8792 5.12793 13.6375 4.47793C13.3958 3.82793 13.05 3.23626 12.6 2.70293C12.8333 2.6196 13.0667 2.56543 13.3 2.54043C13.5333 2.51543 13.7667 2.50293 14 2.50293C15.1 2.50293 16.0417 2.8946 16.825 3.67793C17.6083 4.46126 18 5.40293 18 6.50293ZM2 16.5029H14V15.7029C14 15.5196 13.9542 15.3529 13.8625 15.2029C13.7708 15.0529 13.65 14.9363 13.5 14.8529C12.6 14.4029 11.6917 14.0654 10.775 13.8404C9.85833 13.6154 8.93333 13.5029 8 13.5029C7.06667 13.5029 6.14167 13.6154 5.225 13.8404C4.30833 14.0654 3.4 14.4029 2.5 14.8529C2.35 14.9363 2.22917 15.0529 2.1375 15.2029C2.04583 15.3529 2 15.5196 2 15.7029V16.5029ZM8 8.50293C8.55 8.50293 9.02083 8.3071 9.4125 7.91543C9.80417 7.52376 10 7.05293 10 6.50293C10 5.95293 9.80417 5.4821 9.4125 5.09043C9.02083 4.69876 8.55 4.50293 8 4.50293C7.45 4.50293 6.97917 4.69876 6.5875 5.09043C6.19583 5.4821 6 5.95293 6 6.50293C6 7.05293 6.19583 7.52376 6.5875 7.91543C6.97917 8.3071 7.45 8.50293 8 8.50293Z"
          fill="currentColor"
        />
      </g>
    </svg>,
    childLinks: [
      {
        label: "School",
        path: SCHOOL_CLIENT_LIST,
        permission: { module: "client_school", action: "view" },
      },
      {
        label: "Home Education",
        path: HOME_EDUCATION_LIST,
        permission: { module: "client_home", action: "view" },
      },
      {
        label: "Chatter",
        path: CHATTER_CLIENT_LIST,
        permission: { module: "client_chatter", action: "view" },
      },
      {
        label: "Private",
        path: PRIVATE_CLIENT_LIST,
        permission: { module: "client_private", action: "view" },
      },
      // {
      //   label: "Discharges",
      //   path: DISCHARGES,
      //   permission: { module: "client_discharges", action: "view" },
      // },
      {
        label: "Classrooms",
        path: CLASSROOM_CONSULTATIONS,
        permission: { module: "client_discharges", action: "view" },
      },
    ]
  },
  {
    label: "Users",
    icon: <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
    >
      <mask
        id="mask0_1_3245"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="-1"
        y="-2"
        width="24"
        height="25"
      >
        <rect
          x="-1"
          y="-1.49707"
          width="24"
          height="24"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_1_3245)">
        <path
          d="M0 18.5029V15.7029C0 15.1363 0.145833 14.6154 0.4375 14.1404C0.729167 13.6654 1.11667 13.3029 1.6 13.0529C2.63333 12.5363 3.68333 12.1488 4.75 11.8904C5.81667 11.6321 6.9 11.5029 8 11.5029C9.1 11.5029 10.1833 11.6321 11.25 11.8904C12.3167 12.1488 13.3667 12.5363 14.4 13.0529C14.8833 13.3029 15.2708 13.6654 15.5625 14.1404C15.8542 14.6154 16 15.1363 16 15.7029V18.5029H0ZM18 18.5029V15.5029C18 14.7696 17.7958 14.0654 17.3875 13.3904C16.9792 12.7154 16.4 12.1363 15.65 11.6529C16.5 11.7529 17.3 11.9238 18.05 12.1654C18.8 12.4071 19.5 12.7029 20.15 13.0529C20.75 13.3863 21.2083 13.7571 21.525 14.1654C21.8417 14.5738 22 15.0196 22 15.5029V18.5029H18ZM8 10.5029C6.9 10.5029 5.95833 10.1113 5.175 9.32793C4.39167 8.5446 4 7.60293 4 6.50293C4 5.40293 4.39167 4.46126 5.175 3.67793C5.95833 2.8946 6.9 2.50293 8 2.50293C9.1 2.50293 10.0417 2.8946 10.825 3.67793C11.6083 4.46126 12 5.40293 12 6.50293C12 7.60293 11.6083 8.5446 10.825 9.32793C10.0417 10.1113 9.1 10.5029 8 10.5029ZM18 6.50293C18 7.60293 17.6083 8.5446 16.825 9.32793C16.0417 10.1113 15.1 10.5029 14 10.5029C13.8167 10.5029 13.5833 10.4821 13.3 10.4404C13.0167 10.3988 12.7833 10.3529 12.6 10.3029C13.05 9.7696 13.3958 9.17793 13.6375 8.52793C13.8792 7.87793 14 7.20293 14 6.50293C14 5.80293 13.8792 5.12793 13.6375 4.47793C13.3958 3.82793 13.05 3.23626 12.6 2.70293C12.8333 2.6196 13.0667 2.56543 13.3 2.54043C13.5333 2.51543 13.7667 2.50293 14 2.50293C15.1 2.50293 16.0417 2.8946 16.825 3.67793C17.6083 4.46126 18 5.40293 18 6.50293ZM2 16.5029H14V15.7029C14 15.5196 13.9542 15.3529 13.8625 15.2029C13.7708 15.0529 13.65 14.9363 13.5 14.8529C12.6 14.4029 11.6917 14.0654 10.775 13.8404C9.85833 13.6154 8.93333 13.5029 8 13.5029C7.06667 13.5029 6.14167 13.6154 5.225 13.8404C4.30833 14.0654 3.4 14.4029 2.5 14.8529C2.35 14.9363 2.22917 15.0529 2.1375 15.2029C2.04583 15.3529 2 15.5196 2 15.7029V16.5029ZM8 8.50293C8.55 8.50293 9.02083 8.3071 9.4125 7.91543C9.80417 7.52376 10 7.05293 10 6.50293C10 5.95293 9.80417 5.4821 9.4125 5.09043C9.02083 4.69876 8.55 4.50293 8 4.50293C7.45 4.50293 6.97917 4.69876 6.5875 5.09043C6.19583 5.4821 6 5.95293 6 6.50293C6 7.05293 6.19583 7.52376 6.5875 7.91543C6.97917 8.3071 7.45 8.50293 8 8.50293Z"
          fill="currentColor"
        />
      </g>
    </svg>,
    childLinks: [
      {
        label: "Admin",
        path: MANAGE_USERS_LIST,
        permission: { module: "no_access_for_now", action: "view" },
      },
      {
        label: "Clinicians",
        path: THERAPIST_LIST,
        permission: { module: "therapist_profile", action: "view" },
      },
      {
        label: "Parents",
        path: MANAGE_PARENTS_LIST,
        permission: { module: "parent_profile", action: "view" },
      },
      {
        label: "Teachers",
        path: MANAGE_TEACHERS_LIST,
        permission: { module: "teacher_profile", action: "view" },
      },
      {
        label: "Support Staff",
        path: MANAGE_SUPPORT_STAFF_LIST,
        permission: { module: "support_staff_profile", action: "view" },
      },
    ]
  },
  {
    label: "Multidisciplinary",
    icon: <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <path
        d="M4 14.5029H6V9.50293H4V14.5029ZM12 14.5029H14V4.50293H12V14.5029ZM8 14.5029H10V11.5029H8V14.5029ZM8 9.50293H10V7.50293H8V9.50293ZM2 18.5029C1.45 18.5029 0.979167 18.3071 0.5875 17.9154C0.195833 17.5238 0 17.0529 0 16.5029V2.50293C0 1.95293 0.195833 1.4821 0.5875 1.09043C0.979167 0.698763 1.45 0.50293 2 0.50293H16C16.55 0.50293 17.0208 0.698763 17.4125 1.09043C17.8042 1.4821 18 1.95293 18 2.50293V16.5029C18 17.0529 17.8042 17.5238 17.4125 17.9154C17.0208 18.3071 16.55 18.5029 16 18.5029H2ZM2 16.5029H16V2.50293H2V16.5029Z"
        fill="currentColor"
      />
    </svg>,
    childLinks: [
      {
        label: "Multidisciplinary Assessment",
        path: MDT_ASSESSMENT_LIST,
        permission: { module: "mdt_assessment", action: "view" },
      },
      {
        label: "Manage Status",
        path: MDT_STATUS_LIST,
        permission: { module: "mdt_status", action: "view" },
      },
      {
        label: "MDT Terms",
        path: MDT_TERMS_LIST,
        permission: { module: "mdt_term", action: "view" },
      },
    ]
  },
  {
    label: "My Clipboard",
    icon: <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
    >
      <mask
        id="mask0_1_3245"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="-1"
        y="-2"
        width="24"
        height="25"
      >
        <rect
          x="-1"
          y="-1.49707"
          width="24"
          height="24"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_1_3245)">
        <path
          d="M0 18.5029V15.7029C0 15.1363 0.145833 14.6154 0.4375 14.1404C0.729167 13.6654 1.11667 13.3029 1.6 13.0529C2.63333 12.5363 3.68333 12.1488 4.75 11.8904C5.81667 11.6321 6.9 11.5029 8 11.5029C9.1 11.5029 10.1833 11.6321 11.25 11.8904C12.3167 12.1488 13.3667 12.5363 14.4 13.0529C14.8833 13.3029 15.2708 13.6654 15.5625 14.1404C15.8542 14.6154 16 15.1363 16 15.7029V18.5029H0ZM18 18.5029V15.5029C18 14.7696 17.7958 14.0654 17.3875 13.3904C16.9792 12.7154 16.4 12.1363 15.65 11.6529C16.5 11.7529 17.3 11.9238 18.05 12.1654C18.8 12.4071 19.5 12.7029 20.15 13.0529C20.75 13.3863 21.2083 13.7571 21.525 14.1654C21.8417 14.5738 22 15.0196 22 15.5029V18.5029H18ZM8 10.5029C6.9 10.5029 5.95833 10.1113 5.175 9.32793C4.39167 8.5446 4 7.60293 4 6.50293C4 5.40293 4.39167 4.46126 5.175 3.67793C5.95833 2.8946 6.9 2.50293 8 2.50293C9.1 2.50293 10.0417 2.8946 10.825 3.67793C11.6083 4.46126 12 5.40293 12 6.50293C12 7.60293 11.6083 8.5446 10.825 9.32793C10.0417 10.1113 9.1 10.5029 8 10.5029ZM18 6.50293C18 7.60293 17.6083 8.5446 16.825 9.32793C16.0417 10.1113 15.1 10.5029 14 10.5029C13.8167 10.5029 13.5833 10.4821 13.3 10.4404C13.0167 10.3988 12.7833 10.3529 12.6 10.3029C13.05 9.7696 13.3958 9.17793 13.6375 8.52793C13.8792 7.87793 14 7.20293 14 6.50293C14 5.80293 13.8792 5.12793 13.6375 4.47793C13.3958 3.82793 13.05 3.23626 12.6 2.70293C12.8333 2.6196 13.0667 2.56543 13.3 2.54043C13.5333 2.51543 13.7667 2.50293 14 2.50293C15.1 2.50293 16.0417 2.8946 16.825 3.67793C17.6083 4.46126 18 5.40293 18 6.50293ZM2 16.5029H14V15.7029C14 15.5196 13.9542 15.3529 13.8625 15.2029C13.7708 15.0529 13.65 14.9363 13.5 14.8529C12.6 14.4029 11.6917 14.0654 10.775 13.8404C9.85833 13.6154 8.93333 13.5029 8 13.5029C7.06667 13.5029 6.14167 13.6154 5.225 13.8404C4.30833 14.0654 3.4 14.4029 2.5 14.8529C2.35 14.9363 2.22917 15.0529 2.1375 15.2029C2.04583 15.3529 2 15.5196 2 15.7029V16.5029ZM8 8.50293C8.55 8.50293 9.02083 8.3071 9.4125 7.91543C9.80417 7.52376 10 7.05293 10 6.50293C10 5.95293 9.80417 5.4821 9.4125 5.09043C9.02083 4.69876 8.55 4.50293 8 4.50293C7.45 4.50293 6.97917 4.69876 6.5875 5.09043C6.19583 5.4821 6 5.95293 6 6.50293C6 7.05293 6.19583 7.52376 6.5875 7.91543C6.97917 8.3071 7.45 8.50293 8 8.50293Z"
          fill="currentColor"
        />
      </g>
    </svg>,
    childLinks: [
      {
        label: "Workshop",
        path: WORKSHOPS,
        permission: { module: "report_template_assessment", action: "view" },
      },
      {
        label: "Notes",
        path: NOTES_TABLE,
        permission: { module: "report_template_chatter", action: "view" },
      },
    ]
  },
  {
    label: "Chatter",
    icon: <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M18 7.50281C17.05 7.50281 16.225 7.21947 15.525 6.65281C14.825 6.08614 14.3583 5.36947 14.125 4.50281H7.85C7.66667 5.20281 7.32083 5.80697 6.8125 6.31531C6.30417 6.82364 5.7 7.16947 5 7.35281V13.6278C5.86667 13.8611 6.58333 14.3278 7.15 15.0278C7.71667 15.7278 8 16.5528 8 17.5028C8 18.6028 7.60833 19.5445 6.825 20.3278C6.04167 21.1111 5.1 21.5028 4 21.5028C2.9 21.5028 1.95833 21.1111 1.175 20.3278C0.391667 19.5445 0 18.6028 0 17.5028C0 16.5528 0.283333 15.7278 0.85 15.0278C1.41667 14.3278 2.13333 13.8611 3 13.6278V7.35281C2.13333 7.11947 1.41667 6.65281 0.85 5.95281C0.283333 5.25281 0 4.43614 0 3.50281C0 2.40281 0.391667 1.46114 1.175 0.677808C1.95833 -0.105526 2.9 -0.497192 4 -0.497192C4.93333 -0.497192 5.75 -0.213859 6.45 0.352808C7.15 0.919474 7.61667 1.63614 7.85 2.50281H14.125C14.3583 1.63614 14.825 0.919474 15.525 0.352808C16.225 -0.213859 17.05 -0.497192 18 -0.497192C19.1 -0.497192 20.0417 -0.105526 20.825 0.677808C21.6083 1.46114 22 2.40281 22 3.50281C22 4.60281 21.6083 5.54447 20.825 6.32781C20.0417 7.11114 19.1 7.50281 18 7.50281ZM4 19.5028C4.55 19.5028 5.02083 19.3028 5.4125 18.9028C5.80417 18.5028 6 18.0361 6 17.5028C6 16.9528 5.80417 16.482 5.4125 16.0903C5.02083 15.6986 4.55 15.5028 4 15.5028C3.46667 15.5028 3 15.6986 2.6 16.0903C2.2 16.482 2 16.9528 2 17.5028C2 18.0361 2.2 18.5028 2.6 18.9028C3 19.3028 3.46667 19.5028 4 19.5028ZM4 5.50281C4.55 5.50281 5.02083 5.30697 5.4125 4.91531C5.80417 4.52364 6 4.05281 6 3.50281C6 2.95281 5.80417 2.48197 5.4125 2.09031C5.02083 1.69864 4.55 1.50281 4 1.50281C3.46667 1.50281 3 1.69864 2.6 2.09031C2.2 2.48197 2 2.95281 2 3.50281C2 4.05281 2.2 4.52364 2.6 4.91531C3 5.30697 3.46667 5.50281 4 5.50281ZM18 21.5028C16.9 21.5028 15.9583 21.1111 15.175 20.3278C14.3917 19.5445 14 18.6028 14 17.5028C14 16.4028 14.3917 15.4611 15.175 14.6778C15.9583 13.8945 16.9 13.5028 18 13.5028C19.1 13.5028 20.0417 13.8945 20.825 14.6778C21.6083 15.4611 22 16.4028 22 17.5028C22 18.6028 21.6083 19.5445 20.825 20.3278C20.0417 21.1111 19.1 21.5028 18 21.5028ZM18 19.5028C18.55 19.5028 19.0208 19.3028 19.4125 18.9028C19.8042 18.5028 20 18.0361 20 17.5028C20 16.9528 19.8042 16.482 19.4125 16.0903C19.0208 15.6986 18.55 15.5028 18 15.5028C17.45 15.5028 16.9792 15.6986 16.5875 16.0903C16.1958 16.482 16 16.9528 16 17.5028C16 18.0361 16.1958 18.5028 16.5875 18.9028C16.9792 19.3028 17.45 19.5028 18 19.5028ZM18 5.50281C18.55 5.50281 19.0208 5.30697 19.4125 4.91531C19.8042 4.52364 20 4.05281 20 3.50281C20 2.95281 19.8042 2.48197 19.4125 2.09031C19.0208 1.69864 18.55 1.50281 18 1.50281C17.45 1.50281 16.9792 1.69864 16.5875 2.09031C16.1958 2.48197 16 2.95281 16 3.50281C16 4.05281 16.1958 4.52364 16.5875 4.91531C16.9792 5.30697 17.45 5.50281 18 5.50281Z"
        fill="currentColor"
      />
    </svg>,
    childLinks: [
      {
        label: "Chatter Program Profiles",
        path: CHATTER_PROGRAM_LIST,
        permission: { module: "chatter_program", action: "view" },
      },
      {
        label: "Lesson Plans",
        path: CHATTER_LESSON_LIST,
        permission: { module: "chatter_lesson_plan", action: "view" },
      },
      {
        label: "Chatter Peers",
        path: CHATTER_PEER_LIST,
        permission: { module: "chatter_peer", action: "view" },
      },
      {
        label: "Program Descriptions",
        path: CHATTER_TEMPLATE_LIST,
        permission: { module: "report_template_chatter", action: "view" },
      },
    ]
  },
  // {
  //   label: "Manage School",
  //   icon: <svg
  //     xmlns="http://www.w3.org/2000/svg"
  //     width="23"
  //     height="23"
  //     viewBox="0 0 23 23"
  //     fill="none"
  //   >
  //     <mask
  //       id="mask0_108_5580"
  //       style={{ maskType: "alpha" }}
  //       maskUnits="userSpaceOnUse"
  //       x="-1"
  //       y="-2"
  //       width="24"
  //       height="25"
  //     >
  //       <rect
  //         x="-1"
  //         y="-1.49707"
  //         width="24"
  //         height="24"
  //         fill="#D9D9D9"
  //       />
  //     </mask>
  //     <g mask="url(#mask0_108_5580)">
  //       <path
  //         d="M2 19.5029V5.50293H6V1.50293H16V9.50293H20V19.5029H12V15.5029H10V19.5029H2ZM4 17.5029H6V15.5029H4V17.5029ZM4 13.5029H6V11.5029H4V13.5029ZM4 9.50293H6V7.50293H4V9.50293ZM8 13.5029H10V11.5029H8V13.5029ZM8 9.50293H10V7.50293H8V9.50293ZM8 5.50293H10V3.50293H8V5.50293ZM12 13.5029H14V11.5029H12V13.5029ZM12 9.50293H14V7.50293H12V9.50293ZM12 5.50293H14V3.50293H12V5.50293ZM16 17.5029H18V15.5029H16V17.5029ZM16 13.5029H18V11.5029H16V13.5029Z"
  //         fill="currentColor"
  //       />
  //     </g>
  //   </svg>,
  //   childLinks: [
  //     {
  //       label: "School Profiles",
  //       path: SCHOOL_LIST,
  //       permission: { module: "school_profile", action: "view" },
  //     },
  //     {
  //       label: "School Division",
  //       path: SCHOOL_DIVISON_LIST,
  //       permission: { module: "school_division", action: "view" },
  //     },
  //   ]
  // },
  {
    label: "Library",
    icon: <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
    >
      <mask
        id="mask0_108_5580"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="-1"
        y="-2"
        width="24"
        height="25"
      >
        <rect
          x="-1"
          y="-1.49707"
          width="24"
          height="24"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_108_5580)">
        <path
          d="M2 19.5029V5.50293H6V1.50293H16V9.50293H20V19.5029H12V15.5029H10V19.5029H2ZM4 17.5029H6V15.5029H4V17.5029ZM4 13.5029H6V11.5029H4V13.5029ZM4 9.50293H6V7.50293H4V9.50293ZM8 13.5029H10V11.5029H8V13.5029ZM8 9.50293H10V7.50293H8V9.50293ZM8 5.50293H10V3.50293H8V5.50293ZM12 13.5029H14V11.5029H12V13.5029ZM12 9.50293H14V7.50293H12V9.50293ZM12 5.50293H14V3.50293H12V5.50293ZM16 17.5029H18V15.5029H16V17.5029ZM16 13.5029H18V11.5029H16V13.5029Z"
          fill="currentColor"
        />
      </g>
    </svg>,
    childLinks: [
      {
        label: "Assessments",
        path: ASSESSMENT_TEMPLATE_LIST,
        permission: { module: "report_template_assessment", action: "view" },
      },
      {
        label: "Goals",
        path: GOALS_LIST,
        permission: { module: "goals", action: "view" },
      },
      {
        label: "Disciplines",
        path: DISCIPLINES_LIST,
        permission: { module: "discipline_profile", action: "view" },
      },
      {
        label: "School Divisions",
        path: SCHOOL_DIVISON_LIST,
        permission: { module: "school_division", action: "view" },
      },
      {
        label: "Schools",
        path: SCHOOL_LIST,
        permission: { module: "school_profile", action: "view" },
      },
      {
        label: "Designations",
        path: DESIGNATIONS_LIST,
        permission: { module: "designations", action: "view" },
      },
      {
        label: "Funding Sources",
        path: FUNDING_SOURCE_LIST,
        permission: { module: "funding_sources", action: "view" },
      },
      {
        label: "Service Status",
        path: SERVICE_STATUS_LIST,
        permission: { module: "service_status", action: "view" },
      },
      {
        label: "Client Status",
        path: MANAGE_STATUS_LIST,
        permission: { module: "client_status", action: "view" },
      },
    ]
  },
  // {
  //   label: "Manage Goals",
  //   icon: <svg
  //     xmlns="http://www.w3.org/2000/svg"
  //     width="22"
  //     height="22"
  //     viewBox="0 0 22 22"
  //     fill="none"
  //   >
  //     <path
  //       d="M18 7.50281C17.05 7.50281 16.225 7.21947 15.525 6.65281C14.825 6.08614 14.3583 5.36947 14.125 4.50281H7.85C7.66667 5.20281 7.32083 5.80697 6.8125 6.31531C6.30417 6.82364 5.7 7.16947 5 7.35281V13.6278C5.86667 13.8611 6.58333 14.3278 7.15 15.0278C7.71667 15.7278 8 16.5528 8 17.5028C8 18.6028 7.60833 19.5445 6.825 20.3278C6.04167 21.1111 5.1 21.5028 4 21.5028C2.9 21.5028 1.95833 21.1111 1.175 20.3278C0.391667 19.5445 0 18.6028 0 17.5028C0 16.5528 0.283333 15.7278 0.85 15.0278C1.41667 14.3278 2.13333 13.8611 3 13.6278V7.35281C2.13333 7.11947 1.41667 6.65281 0.85 5.95281C0.283333 5.25281 0 4.43614 0 3.50281C0 2.40281 0.391667 1.46114 1.175 0.677808C1.95833 -0.105526 2.9 -0.497192 4 -0.497192C4.93333 -0.497192 5.75 -0.213859 6.45 0.352808C7.15 0.919474 7.61667 1.63614 7.85 2.50281H14.125C14.3583 1.63614 14.825 0.919474 15.525 0.352808C16.225 -0.213859 17.05 -0.497192 18 -0.497192C19.1 -0.497192 20.0417 -0.105526 20.825 0.677808C21.6083 1.46114 22 2.40281 22 3.50281C22 4.60281 21.6083 5.54447 20.825 6.32781C20.0417 7.11114 19.1 7.50281 18 7.50281ZM4 19.5028C4.55 19.5028 5.02083 19.3028 5.4125 18.9028C5.80417 18.5028 6 18.0361 6 17.5028C6 16.9528 5.80417 16.482 5.4125 16.0903C5.02083 15.6986 4.55 15.5028 4 15.5028C3.46667 15.5028 3 15.6986 2.6 16.0903C2.2 16.482 2 16.9528 2 17.5028C2 18.0361 2.2 18.5028 2.6 18.9028C3 19.3028 3.46667 19.5028 4 19.5028ZM4 5.50281C4.55 5.50281 5.02083 5.30697 5.4125 4.91531C5.80417 4.52364 6 4.05281 6 3.50281C6 2.95281 5.80417 2.48197 5.4125 2.09031C5.02083 1.69864 4.55 1.50281 4 1.50281C3.46667 1.50281 3 1.69864 2.6 2.09031C2.2 2.48197 2 2.95281 2 3.50281C2 4.05281 2.2 4.52364 2.6 4.91531C3 5.30697 3.46667 5.50281 4 5.50281ZM18 21.5028C16.9 21.5028 15.9583 21.1111 15.175 20.3278C14.3917 19.5445 14 18.6028 14 17.5028C14 16.4028 14.3917 15.4611 15.175 14.6778C15.9583 13.8945 16.9 13.5028 18 13.5028C19.1 13.5028 20.0417 13.8945 20.825 14.6778C21.6083 15.4611 22 16.4028 22 17.5028C22 18.6028 21.6083 19.5445 20.825 20.3278C20.0417 21.1111 19.1 21.5028 18 21.5028ZM18 19.5028C18.55 19.5028 19.0208 19.3028 19.4125 18.9028C19.8042 18.5028 20 18.0361 20 17.5028C20 16.9528 19.8042 16.482 19.4125 16.0903C19.0208 15.6986 18.55 15.5028 18 15.5028C17.45 15.5028 16.9792 15.6986 16.5875 16.0903C16.1958 16.482 16 16.9528 16 17.5028C16 18.0361 16.1958 18.5028 16.5875 18.9028C16.9792 19.3028 17.45 19.5028 18 19.5028ZM18 5.50281C18.55 5.50281 19.0208 5.30697 19.4125 4.91531C19.8042 4.52364 20 4.05281 20 3.50281C20 2.95281 19.8042 2.48197 19.4125 2.09031C19.0208 1.69864 18.55 1.50281 18 1.50281C17.45 1.50281 16.9792 1.69864 16.5875 2.09031C16.1958 2.48197 16 2.95281 16 3.50281C16 4.05281 16.1958 4.52364 16.5875 4.91531C16.9792 5.30697 17.45 5.50281 18 5.50281Z"
  //       fill="currentColor"
  //     />
  //   </svg>,
  //   childLinks: [
  //     {
  //       label: "All Goals",
  //       path: GOALS_LIST,
  //       permission: { module: "goals", action: "view" },
  //     }
  //   ]
  // },
  // {
  //   label: "My Library",
  //   icon: <svg
  //     xmlns="http://www.w3.org/2000/svg"
  //     width="23"
  //     height="23"
  //     viewBox="0 0 23 23"
  //     fill="none"
  //   >
  //     <mask
  //       id="mask0_1_3245"
  //       style={{ maskType: "alpha" }}
  //       maskUnits="userSpaceOnUse"
  //       x="-1"
  //       y="-2"
  //       width="24"
  //       height="25"
  //     >
  //       <rect
  //         x="-1"
  //         y="-1.49707"
  //         width="24"
  //         height="24"
  //         fill="#D9D9D9"
  //       />
  //     </mask>
  //     <g mask="url(#mask0_1_3245)">
  //       <path
  //         d="M0 18.5029V15.7029C0 15.1363 0.145833 14.6154 0.4375 14.1404C0.729167 13.6654 1.11667 13.3029 1.6 13.0529C2.63333 12.5363 3.68333 12.1488 4.75 11.8904C5.81667 11.6321 6.9 11.5029 8 11.5029C9.1 11.5029 10.1833 11.6321 11.25 11.8904C12.3167 12.1488 13.3667 12.5363 14.4 13.0529C14.8833 13.3029 15.2708 13.6654 15.5625 14.1404C15.8542 14.6154 16 15.1363 16 15.7029V18.5029H0ZM18 18.5029V15.5029C18 14.7696 17.7958 14.0654 17.3875 13.3904C16.9792 12.7154 16.4 12.1363 15.65 11.6529C16.5 11.7529 17.3 11.9238 18.05 12.1654C18.8 12.4071 19.5 12.7029 20.15 13.0529C20.75 13.3863 21.2083 13.7571 21.525 14.1654C21.8417 14.5738 22 15.0196 22 15.5029V18.5029H18ZM8 10.5029C6.9 10.5029 5.95833 10.1113 5.175 9.32793C4.39167 8.5446 4 7.60293 4 6.50293C4 5.40293 4.39167 4.46126 5.175 3.67793C5.95833 2.8946 6.9 2.50293 8 2.50293C9.1 2.50293 10.0417 2.8946 10.825 3.67793C11.6083 4.46126 12 5.40293 12 6.50293C12 7.60293 11.6083 8.5446 10.825 9.32793C10.0417 10.1113 9.1 10.5029 8 10.5029ZM18 6.50293C18 7.60293 17.6083 8.5446 16.825 9.32793C16.0417 10.1113 15.1 10.5029 14 10.5029C13.8167 10.5029 13.5833 10.4821 13.3 10.4404C13.0167 10.3988 12.7833 10.3529 12.6 10.3029C13.05 9.7696 13.3958 9.17793 13.6375 8.52793C13.8792 7.87793 14 7.20293 14 6.50293C14 5.80293 13.8792 5.12793 13.6375 4.47793C13.3958 3.82793 13.05 3.23626 12.6 2.70293C12.8333 2.6196 13.0667 2.56543 13.3 2.54043C13.5333 2.51543 13.7667 2.50293 14 2.50293C15.1 2.50293 16.0417 2.8946 16.825 3.67793C17.6083 4.46126 18 5.40293 18 6.50293ZM2 16.5029H14V15.7029C14 15.5196 13.9542 15.3529 13.8625 15.2029C13.7708 15.0529 13.65 14.9363 13.5 14.8529C12.6 14.4029 11.6917 14.0654 10.775 13.8404C9.85833 13.6154 8.93333 13.5029 8 13.5029C7.06667 13.5029 6.14167 13.6154 5.225 13.8404C4.30833 14.0654 3.4 14.4029 2.5 14.8529C2.35 14.9363 2.22917 15.0529 2.1375 15.2029C2.04583 15.3529 2 15.5196 2 15.7029V16.5029ZM8 8.50293C8.55 8.50293 9.02083 8.3071 9.4125 7.91543C9.80417 7.52376 10 7.05293 10 6.50293C10 5.95293 9.80417 5.4821 9.4125 5.09043C9.02083 4.69876 8.55 4.50293 8 4.50293C7.45 4.50293 6.97917 4.69876 6.5875 5.09043C6.19583 5.4821 6 5.95293 6 6.50293C6 7.05293 6.19583 7.52376 6.5875 7.91543C6.97917 8.3071 7.45 8.50293 8 8.50293Z"
  //         fill="currentColor"
  //       />
  //     </g>
  //   </svg>,
  //   childLinks: [
  //     {
  //       label: "Assessments",
  //       path: ASSESSMENT_TEMPLATE_LIST,
  //       permission: { module: "report_template_assessment", action: "view" },
  //     },
  //   ]
  // },
  // {
  //   label: "Manage Consent Form",
  //   icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-file-pdf" viewBox="0 0 16 16">
  //     <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1" />
  //     <path d="M4.603 12.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.187-.012.395-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.065.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.6 11.6 0 0 0-1.997.406 11.3 11.3 0 0 1-1.021 1.51c-.29.35-.608.655-.926.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.244.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 5.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
  //   </svg>,
  //   childLinks: [
  //     {
  //       label: "Consent Form",
  //       path: MANAGE_CONSENT_FORM,
  //       permission: { module: "consent_form", action: "view" },
  //     },
  //   ]
  // },
  // {
  //   label: "Manage Export",
  //   icon: <svg width="20" height="18" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  //     <path d="M0.459961 12.5999V11.04H8.25985V12.5999H0.459961ZM3.57992 9.47998V3.10357L1.55194 5.11204L0.459961 4.02006L4.3599 0.120117L8.25985 4.02006L7.16786 5.11204L5.13989 3.10357V9.47998H3.57992Z" fill="#1C1B1F" />
  //   </svg>,
  //   path: MANAGE_EXPORT,
  //   permission: { module: "manage_exports", action: "view" },
  // },
  {
    label: "Policy & Agreements",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_7806_601)">
        <mask id="mask0_7806_601" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="-1" y="-2" width="24" height="25">
          <rect x="-1" y="-1.49719" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_7806_601)">
          <path d="M6 15.5028H8V10.5028H6V15.5028ZM14 15.5028H16V5.50281H14V15.5028ZM10 15.5028H12V12.5028H10V15.5028ZM10 10.5028H12V8.50281H10V10.5028ZM4 19.5028C3.45 19.5028 2.97917 19.307 2.5875 18.9153C2.19583 18.5236 2 18.0528 2 17.5028V3.50281C2 2.95281 2.19583 2.48197 2.5875 2.09031C2.97917 1.69864 3.45 1.50281 4 1.50281H18C18.55 1.50281 19.0208 1.69864 19.4125 2.09031C19.8042 2.48197 20 2.95281 20 3.50281V17.5028C20 18.0528 19.8042 18.5236 19.4125 18.9153C19.0208 19.307 18.55 19.5028 18 19.5028H4ZM4 17.5028H18V3.50281H4V17.5028Z" fill="#071E3E" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_7806_601">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>,
    childLinks: [
      {
        label: "Policies",
        path: POLICY_AND_PROCEDURE,
        permission: { module: "policy_and_procedures", action: "view" },
      },
      {
        label: "Email",
        path: MANAGE_NOTIFICATION_EMAIL_TEMPLATE_LIST,
        permission: { module: "email_notification", action: "view" },
      },
      {
        label: "Firebase",
        path: MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_LIST,
        permission: { module: "firebase_notification", action: "view" },
      },
    ]
  },
  {
    label: "CMS",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_7806_601)">
        <mask id="mask0_7806_601" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="-1" y="-2" width="24" height="25">
          <rect x="-1" y="-1.49719" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_7806_601)">
          <path d="M6 15.5028H8V10.5028H6V15.5028ZM14 15.5028H16V5.50281H14V15.5028ZM10 15.5028H12V12.5028H10V15.5028ZM10 10.5028H12V8.50281H10V10.5028ZM4 19.5028C3.45 19.5028 2.97917 19.307 2.5875 18.9153C2.19583 18.5236 2 18.0528 2 17.5028V3.50281C2 2.95281 2.19583 2.48197 2.5875 2.09031C2.97917 1.69864 3.45 1.50281 4 1.50281H18C18.55 1.50281 19.0208 1.69864 19.4125 2.09031C19.8042 2.48197 20 2.95281 20 3.50281V17.5028C20 18.0528 19.8042 18.5236 19.4125 18.9153C19.0208 19.307 18.55 19.5028 18 19.5028H4ZM4 17.5028H18V3.50281H4V17.5028Z" fill="#071E3E" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_7806_601">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>,
    path: MANAGE_CMS_LIST,
    permission: { module: "cms", action: "view" },
  },
  // {
  //   label: "Manage Email Notification",
  //   icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //     <g clip-path="url(#clip0_2636_5294)">
  //       <mask id="mask0_2636_5294" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="-1" y="-2" width="24" height="25">
  //         <rect x="-1" y="-1.49719" width="24" height="24" fill="#D9D9D9" />
  //       </mask>
  //       <g mask="url(#mask0_2636_5294)">
  //         <path d="M-0.05 11.8028C-0.35 11.2028 -0.583333 10.5945 -0.75 9.97781C-0.916667 9.36114 -1 8.73614 -1 8.10281C-1 6.23614 -0.366667 4.66947 0.9 3.40281C2.16667 2.13614 3.73333 1.50281 5.6 1.50281C6.65 1.50281 7.65 1.72364 8.6 2.16531C9.55 2.60697 10.35 3.21947 11 4.00281C11.65 3.21947 12.45 2.60697 13.4 2.16531C14.35 1.72364 15.35 1.50281 16.4 1.50281C18.2667 1.50281 19.8333 2.13614 21.1 3.40281C22.3667 4.66947 23 6.23614 23 8.10281C23 8.73614 22.9167 9.36114 22.75 9.97781C22.5833 10.5945 22.35 11.2028 22.05 11.8028C21.8667 11.4861 21.65 11.2028 21.4 10.9528C21.15 10.7028 20.8583 10.5028 20.525 10.3528C20.675 9.96947 20.7917 9.59447 20.875 9.22781C20.9583 8.86114 21 8.48614 21 8.10281C21 6.80281 20.5583 5.71114 19.675 4.82781C18.7917 3.94447 17.7 3.50281 16.4 3.50281C15.05 3.50281 14.0125 3.87364 13.2875 4.61531C12.5625 5.35697 11.8 6.18614 11 7.10281C10.2 6.16947 9.4375 5.33614 8.7125 4.60281C7.9875 3.86947 6.95 3.50281 5.6 3.50281C4.3 3.50281 3.20833 3.94447 2.325 4.82781C1.44167 5.71114 1 6.80281 1 8.10281C1 8.48614 1.04167 8.86114 1.125 9.22781C1.20833 9.59447 1.325 9.96947 1.475 10.3528C1.14167 10.5028 0.85 10.7028 0.6 10.9528C0.35 11.2028 0.133333 11.4861 -0.05 11.8028ZM-1 20.5028V18.9278C-1 18.1945 -0.629167 17.607 0.1125 17.1653C0.854167 16.7236 1.81667 16.5028 3 16.5028C3.21667 16.5028 3.425 16.507 3.625 16.5153C3.825 16.5236 4.01667 16.5445 4.2 16.5778C3.96667 16.9111 3.79167 17.2695 3.675 17.6528C3.55833 18.0361 3.5 18.4445 3.5 18.8778V20.5028H-1ZM5 20.5028V18.8778C5 17.7945 5.55417 16.9195 6.6625 16.2528C7.77083 15.5861 9.21667 15.2528 11 15.2528C12.8 15.2528 14.25 15.5861 15.35 16.2528C16.45 16.9195 17 17.7945 17 18.8778V20.5028H5ZM18.5 20.5028V18.8778C18.5 18.4445 18.4458 18.0361 18.3375 17.6528C18.2292 17.2695 18.0667 16.9111 17.85 16.5778C18.0333 16.5445 18.2208 16.5236 18.4125 16.5153C18.6042 16.507 18.8 16.5028 19 16.5028C20.2 16.5028 21.1667 16.7236 21.9 17.1653C22.6333 17.607 23 18.1945 23 18.9278V20.5028H18.5ZM11 17.2528C10.05 17.2528 9.2 17.3778 8.45 17.6278C7.7 17.8778 7.25833 18.1695 7.125 18.5028H14.9C14.75 18.1695 14.3042 17.8778 13.5625 17.6278C12.8208 17.3778 11.9667 17.2528 11 17.2528ZM3 15.5028C2.45 15.5028 1.97917 15.307 1.5875 14.9153C1.19583 14.5236 1 14.0528 1 13.5028C1 12.9361 1.19583 12.4611 1.5875 12.0778C1.97917 11.6945 2.45 11.5028 3 11.5028C3.56667 11.5028 4.04167 11.6945 4.425 12.0778C4.80833 12.4611 5 12.9361 5 13.5028C5 14.0528 4.80833 14.5236 4.425 14.9153C4.04167 15.307 3.56667 15.5028 3 15.5028ZM19 15.5028C18.45 15.5028 17.9792 15.307 17.5875 14.9153C17.1958 14.5236 17 14.0528 17 13.5028C17 12.9361 17.1958 12.4611 17.5875 12.0778C17.9792 11.6945 18.45 11.5028 19 11.5028C19.5667 11.5028 20.0417 11.6945 20.425 12.0778C20.8083 12.4611 21 12.9361 21 13.5028C21 14.0528 20.8083 14.5236 20.425 14.9153C20.0417 15.307 19.5667 15.5028 19 15.5028ZM11 14.5028C10.1667 14.5028 9.45833 14.2111 8.875 13.6278C8.29167 13.0445 8 12.3361 8 11.5028C8 10.6528 8.29167 9.94031 8.875 9.36531C9.45833 8.79031 10.1667 8.50281 11 8.50281C11.85 8.50281 12.5625 8.79031 13.1375 9.36531C13.7125 9.94031 14 10.6528 14 11.5028C14 12.3361 13.7125 13.0445 13.1375 13.6278C12.5625 14.2111 11.85 14.5028 11 14.5028ZM11 10.5028C10.7167 10.5028 10.4792 10.5986 10.2875 10.7903C10.0958 10.982 10 11.2195 10 11.5028C10 11.7861 10.0958 12.0236 10.2875 12.2153C10.4792 12.407 10.7167 12.5028 11 12.5028C11.2833 12.5028 11.5208 12.407 11.7125 12.2153C11.9042 12.0236 12 11.7861 12 11.5028C12 11.2195 11.9042 10.982 11.7125 10.7903C11.5208 10.5986 11.2833 10.5028 11 10.5028Z" fill="#071E3E" />
  //       </g>
  //     </g>
  //     <defs>
  //       <clipPath id="clip0_2636_5294">
  //         <rect width="24" height="24" fill="white" />
  //       </clipPath>
  //     </defs>
  //   </svg>,
  //   path: MANAGE_NOTIFICATION_EMAIL_TEMPLATE_LIST,
  //   permission: { module: "email_notification", action: "view" },
  // },
  // {
  //   label: "Manage Firebase Notification",
  //   icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //     <g clip-path="url(#clip0_2636_5294)">
  //       <mask id="mask0_2636_5294" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="-1" y="-2" width="24" height="25">
  //         <rect x="-1" y="-1.49719" width="24" height="24" fill="#D9D9D9" />
  //       </mask>
  //       <g mask="url(#mask0_2636_5294)">
  //         <path d="M-0.05 11.8028C-0.35 11.2028 -0.583333 10.5945 -0.75 9.97781C-0.916667 9.36114 -1 8.73614 -1 8.10281C-1 6.23614 -0.366667 4.66947 0.9 3.40281C2.16667 2.13614 3.73333 1.50281 5.6 1.50281C6.65 1.50281 7.65 1.72364 8.6 2.16531C9.55 2.60697 10.35 3.21947 11 4.00281C11.65 3.21947 12.45 2.60697 13.4 2.16531C14.35 1.72364 15.35 1.50281 16.4 1.50281C18.2667 1.50281 19.8333 2.13614 21.1 3.40281C22.3667 4.66947 23 6.23614 23 8.10281C23 8.73614 22.9167 9.36114 22.75 9.97781C22.5833 10.5945 22.35 11.2028 22.05 11.8028C21.8667 11.4861 21.65 11.2028 21.4 10.9528C21.15 10.7028 20.8583 10.5028 20.525 10.3528C20.675 9.96947 20.7917 9.59447 20.875 9.22781C20.9583 8.86114 21 8.48614 21 8.10281C21 6.80281 20.5583 5.71114 19.675 4.82781C18.7917 3.94447 17.7 3.50281 16.4 3.50281C15.05 3.50281 14.0125 3.87364 13.2875 4.61531C12.5625 5.35697 11.8 6.18614 11 7.10281C10.2 6.16947 9.4375 5.33614 8.7125 4.60281C7.9875 3.86947 6.95 3.50281 5.6 3.50281C4.3 3.50281 3.20833 3.94447 2.325 4.82781C1.44167 5.71114 1 6.80281 1 8.10281C1 8.48614 1.04167 8.86114 1.125 9.22781C1.20833 9.59447 1.325 9.96947 1.475 10.3528C1.14167 10.5028 0.85 10.7028 0.6 10.9528C0.35 11.2028 0.133333 11.4861 -0.05 11.8028ZM-1 20.5028V18.9278C-1 18.1945 -0.629167 17.607 0.1125 17.1653C0.854167 16.7236 1.81667 16.5028 3 16.5028C3.21667 16.5028 3.425 16.507 3.625 16.5153C3.825 16.5236 4.01667 16.5445 4.2 16.5778C3.96667 16.9111 3.79167 17.2695 3.675 17.6528C3.55833 18.0361 3.5 18.4445 3.5 18.8778V20.5028H-1ZM5 20.5028V18.8778C5 17.7945 5.55417 16.9195 6.6625 16.2528C7.77083 15.5861 9.21667 15.2528 11 15.2528C12.8 15.2528 14.25 15.5861 15.35 16.2528C16.45 16.9195 17 17.7945 17 18.8778V20.5028H5ZM18.5 20.5028V18.8778C18.5 18.4445 18.4458 18.0361 18.3375 17.6528C18.2292 17.2695 18.0667 16.9111 17.85 16.5778C18.0333 16.5445 18.2208 16.5236 18.4125 16.5153C18.6042 16.507 18.8 16.5028 19 16.5028C20.2 16.5028 21.1667 16.7236 21.9 17.1653C22.6333 17.607 23 18.1945 23 18.9278V20.5028H18.5ZM11 17.2528C10.05 17.2528 9.2 17.3778 8.45 17.6278C7.7 17.8778 7.25833 18.1695 7.125 18.5028H14.9C14.75 18.1695 14.3042 17.8778 13.5625 17.6278C12.8208 17.3778 11.9667 17.2528 11 17.2528ZM3 15.5028C2.45 15.5028 1.97917 15.307 1.5875 14.9153C1.19583 14.5236 1 14.0528 1 13.5028C1 12.9361 1.19583 12.4611 1.5875 12.0778C1.97917 11.6945 2.45 11.5028 3 11.5028C3.56667 11.5028 4.04167 11.6945 4.425 12.0778C4.80833 12.4611 5 12.9361 5 13.5028C5 14.0528 4.80833 14.5236 4.425 14.9153C4.04167 15.307 3.56667 15.5028 3 15.5028ZM19 15.5028C18.45 15.5028 17.9792 15.307 17.5875 14.9153C17.1958 14.5236 17 14.0528 17 13.5028C17 12.9361 17.1958 12.4611 17.5875 12.0778C17.9792 11.6945 18.45 11.5028 19 11.5028C19.5667 11.5028 20.0417 11.6945 20.425 12.0778C20.8083 12.4611 21 12.9361 21 13.5028C21 14.0528 20.8083 14.5236 20.425 14.9153C20.0417 15.307 19.5667 15.5028 19 15.5028ZM11 14.5028C10.1667 14.5028 9.45833 14.2111 8.875 13.6278C8.29167 13.0445 8 12.3361 8 11.5028C8 10.6528 8.29167 9.94031 8.875 9.36531C9.45833 8.79031 10.1667 8.50281 11 8.50281C11.85 8.50281 12.5625 8.79031 13.1375 9.36531C13.7125 9.94031 14 10.6528 14 11.5028C14 12.3361 13.7125 13.0445 13.1375 13.6278C12.5625 14.2111 11.85 14.5028 11 14.5028ZM11 10.5028C10.7167 10.5028 10.4792 10.5986 10.2875 10.7903C10.0958 10.982 10 11.2195 10 11.5028C10 11.7861 10.0958 12.0236 10.2875 12.2153C10.4792 12.407 10.7167 12.5028 11 12.5028C11.2833 12.5028 11.5208 12.407 11.7125 12.2153C11.9042 12.0236 12 11.7861 12 11.5028C12 11.2195 11.9042 10.982 11.7125 10.7903C11.5208 10.5986 11.2833 10.5028 11 10.5028Z" fill="#071E3E" />
  //       </g>
  //     </g>
  //     <defs>
  //       <clipPath id="clip0_2636_5294">
  //         <rect width="24" height="24" fill="white" />
  //       </clipPath>
  //     </defs>
  //   </svg>,
  //   path: MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_LIST,
  //   permission: { module: "firebase_notification", action: "view" },
  // },
  // {
  //   label: "Designations",
  //   icon: <svg
  //     xmlns="http://www.w3.org/2000/svg"
  //     width="23"
  //     height="23"
  //     viewBox="0 0 23 23"
  //     fill="none"
  //   >
  //     <mask
  //       id="mask0_0_16042"
  //       style={{ maskType: "alpha" }}
  //       maskUnits="userSpaceOnUse"
  //       x="-1"
  //       y="-2"
  //       width="24"
  //       height="25"
  //     >
  //       <rect
  //         x="-1"
  //         y="-1.49707"
  //         width="24"
  //         height="24"
  //         fill="#D9D9D9"
  //       />
  //     </mask>
  //     <g mask="url(#mask0_0_16042)">
  //       <path
  //         d="M4 19.5029C3.45 19.5029 2.97917 19.3071 2.5875 18.9154C2.19583 18.5238 2 18.0529 2 17.5029V3.50293C2 2.95293 2.19583 2.4821 2.5875 2.09043C2.97917 1.69876 3.45 1.50293 4 1.50293H8.2C8.43333 0.90293 8.8 0.419596 9.3 0.0529297C9.8 -0.313737 10.3667 -0.49707 11 -0.49707C11.6333 -0.49707 12.2 -0.313737 12.7 0.0529297C13.2 0.419596 13.5667 0.90293 13.8 1.50293H18C18.55 1.50293 19.0208 1.69876 19.4125 2.09043C19.8042 2.4821 20 2.95293 20 3.50293V17.5029C20 18.0529 19.8042 18.5238 19.4125 18.9154C19.0208 19.3071 18.55 19.5029 18 19.5029H4ZM11 2.75293C11.2167 2.75293 11.3958 2.6821 11.5375 2.54043C11.6792 2.39876 11.75 2.2196 11.75 2.00293C11.75 1.78626 11.6792 1.6071 11.5375 1.46543C11.3958 1.32376 11.2167 1.25293 11 1.25293C10.7833 1.25293 10.6042 1.32376 10.4625 1.46543C10.3208 1.6071 10.25 1.78626 10.25 2.00293C10.25 2.2196 10.3208 2.39876 10.4625 2.54043C10.6042 2.6821 10.7833 2.75293 11 2.75293ZM4 16.3529C4.9 15.4696 5.94583 14.7738 7.1375 14.2654C8.32917 13.7571 9.61667 13.5029 11 13.5029C12.3833 13.5029 13.6708 13.7571 14.8625 14.2654C16.0542 14.7738 17.1 15.4696 18 16.3529V3.50293H4V16.3529ZM11 11.5029C11.9667 11.5029 12.7917 11.1613 13.475 10.4779C14.1583 9.7946 14.5 8.9696 14.5 8.00293C14.5 7.03626 14.1583 6.21126 13.475 5.52793C12.7917 4.8446 11.9667 4.50293 11 4.50293C10.0333 4.50293 9.20833 4.8446 8.525 5.52793C7.84167 6.21126 7.5 7.03626 7.5 8.00293C7.5 8.9696 7.84167 9.7946 8.525 10.4779C9.20833 11.1613 10.0333 11.5029 11 11.5029ZM6 17.5029H16V17.2529C15.3 16.6696 14.525 16.2321 13.675 15.9404C12.825 15.6488 11.9333 15.5029 11 15.5029C10.0667 15.5029 9.175 15.6488 8.325 15.9404C7.475 16.2321 6.7 16.6696 6 17.2529V17.5029ZM11 9.50293C10.5833 9.50293 10.2292 9.3571 9.9375 9.06543C9.64583 8.77376 9.5 8.4196 9.5 8.00293C9.5 7.58626 9.64583 7.2321 9.9375 6.94043C10.2292 6.64876 10.5833 6.50293 11 6.50293C11.4167 6.50293 11.7708 6.64876 12.0625 6.94043C12.3542 7.2321 12.5 7.58626 12.5 8.00293C12.5 8.4196 12.3542 8.77376 12.0625 9.06543C11.7708 9.3571 11.4167 9.50293 11 9.50293Z"
  //         fill="currentColor"
  //       />
  //     </g>
  //   </svg>,
  //   path: DESIGNATIONS_LIST,
  //   permission: { module: "designation", action: "view" },
  // },
  // {
  //   label: "Labels",
  //   icon: <svg
  //     xmlns="http://www.w3.org/2000/svg"
  //     width="23"
  //     height="23"
  //     viewBox="0 0 23 23"
  //     fill="none"
  //   >
  //     <mask
  //       id="mask0_0_16051"
  //       style={{ maskType: "alpha" }}
  //       maskUnits="userSpaceOnUse"
  //       x="-1"
  //       y="-2"
  //       width="24"
  //       height="25"
  //     >
  //       <rect
  //         x="-1"
  //         y="-1.49707"
  //         width="24"
  //         height="24"
  //         fill="#D9D9D9"
  //       />
  //     </mask>
  //     <g mask="url(#mask0_0_16051)">
  //       <path
  //         d="M6 0.50293H16V8.35293C16 8.73626 15.9167 9.07793 15.75 9.37793C15.5833 9.67793 15.35 9.9196 15.05 10.1029L11.5 12.2029L12.2 14.5029H16L12.9 16.7029L14.1 20.5029L11 18.1529L7.9 20.5029L9.1 16.7029L6 14.5029H9.8L10.5 12.2029L6.95 10.1029C6.65 9.9196 6.41667 9.67793 6.25 9.37793C6.08333 9.07793 6 8.73626 6 8.35293V0.50293ZM8 2.50293V8.35293L10 9.55293V2.50293H8ZM14 2.50293H12V9.55293L14 8.35293V2.50293Z"
  //         fill="currentColor"
  //       />
  //     </g>
  //   </svg>,
  //   childLinks: [
  //     {
  //       label: "Manage Status",
  //       path: MANAGE_STATUS_LIST,
  //       permission: { module: "client_status", action: "view" },
  //     },
  //     {
  //       label: "Service Status",
  //       path: SERVICE_STATUS_LIST,
  //       permission: { module: "service_status", action: "view" },
  //     },
  //   ]
  // },
  // {
  //   label: "Manage Funding Sources",
  //   icon: <svg
  //     xmlns="http://www.w3.org/2000/svg"
  //     width="23"
  //     height="23"
  //     viewBox="0 0 23 23"
  //     fill="none"
  //   >
  //     <mask
  //       id="mask0_2_23490"
  //       style={{ maskType: "alpha" }}
  //       maskUnits="userSpaceOnUse"
  //       x="-1"
  //       y="-2"
  //       width="24"
  //       height="25"
  //     >
  //       <rect
  //         x="-1"
  //         y="-1.49719"
  //         width="24"
  //         height="24"
  //         fill="#D9D9D9"
  //       />
  //     </mask>
  //     <g mask="url(#mask0_2_23490)">
  //       <path
  //         d="M16 19.5278C15.8667 19.5278 15.7333 19.5111 15.6 19.4778C15.4667 19.4445 15.3417 19.3861 15.225 19.3028L12.225 17.5528C11.9917 17.4195 11.8125 17.2403 11.6875 17.0153C11.5625 16.7903 11.5 16.5445 11.5 16.2778V12.7528C11.5 12.4861 11.5625 12.2403 11.6875 12.0153C11.8125 11.7903 11.9917 11.6111 12.225 11.4778L15.225 9.72781C15.3417 9.64447 15.4667 9.58614 15.6 9.55281C15.7333 9.51947 15.8667 9.50281 16 9.50281C16.1333 9.50281 16.2625 9.52364 16.3875 9.56531C16.5125 9.60697 16.6333 9.66114 16.75 9.72781L19.75 11.4778C19.9833 11.6111 20.1667 11.7903 20.3 12.0153C20.4333 12.2403 20.5 12.4861 20.5 12.7528V16.2778C20.5 16.5445 20.4333 16.7903 20.3 17.0153C20.1667 17.2403 19.9833 17.4195 19.75 17.5528L16.75 19.3028C16.6333 19.3695 16.5125 19.4236 16.3875 19.4653C16.2625 19.507 16.1333 19.5278 16 19.5278ZM9 10.5028C7.9 10.5028 6.95833 10.1111 6.175 9.32781C5.39167 8.54447 5 7.60281 5 6.50281C5 5.40281 5.39167 4.46114 6.175 3.67781C6.95833 2.89447 7.9 2.50281 9 2.50281C10.1 2.50281 11.0417 2.89447 11.825 3.67781C12.6083 4.46114 13 5.40281 13 6.50281C13 7.60281 12.6083 8.54447 11.825 9.32781C11.0417 10.1111 10.1 10.5028 9 10.5028ZM1 18.5028V15.7028C1 15.1528 1.14167 14.6361 1.425 14.1528C1.70833 13.6695 2.1 13.3028 2.6 13.0528C3.45 12.6195 4.40833 12.2528 5.475 11.9528C6.54167 11.6528 7.71667 11.5028 9 11.5028H9.35C9.45 11.5028 9.55 11.5195 9.65 11.5528C9.51667 11.8528 9.40417 12.1653 9.3125 12.4903C9.22083 12.8153 9.15 13.1528 9.1 13.5028H9C7.81667 13.5028 6.75417 13.6528 5.8125 13.9528C4.87083 14.2528 4.1 14.5528 3.5 14.8528C3.35 14.9361 3.22917 15.0528 3.1375 15.2028C3.04583 15.3528 3 15.5195 3 15.7028V16.5028H9.3C9.4 16.8528 9.53333 17.1986 9.7 17.5403C9.86667 17.882 10.05 18.2028 10.25 18.5028H1ZM9 8.50281C9.55 8.50281 10.0208 8.30697 10.4125 7.91531C10.8042 7.52364 11 7.05281 11 6.50281C11 5.95281 10.8042 5.48197 10.4125 5.09031C10.0208 4.69864 9.55 4.50281 9 4.50281C8.45 4.50281 7.97917 4.69864 7.5875 5.09031C7.19583 5.48197 7 5.95281 7 6.50281C7 7.05281 7.19583 7.52364 7.5875 7.91531C7.97917 8.30697 8.45 8.50281 9 8.50281ZM13.65 12.3528L16 13.7278L18.35 12.3528L16 11.0028L13.65 12.3528ZM16.75 17.5528L19 16.2528V13.5028L16.75 14.8278V17.5528ZM13 16.2528L15.25 17.5778V14.8528L13 13.5278V16.2528Z"
  //         fill="currentColor"
  //       />
  //     </g>
  //   </svg>,
  //   path: FUNDING_SOURCE_LIST,
  //   permission: { module: "funding_source", action: "view" },
  // },
  {
    label: "Audit Logs",
    icon: <svg
      width="18"
      height="18"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill="#071e3e" d="M0 24q0 0.832 0.576 1.44t1.44 0.576h1.984q0 2.496 1.76 4.224t4.256 1.76h6.688q-2.144-1.504-3.456-4h-3.232q-0.832 0-1.44-0.576t-0.576-1.408v-20q0-0.832 0.576-1.408t1.44-0.608h16q0.8 0 1.408 0.608t0.576 1.408v7.232q2.496 1.312 4 3.456v-10.688q0-2.496-1.76-4.256t-4.224-1.76h-16q-2.496 0-4.256 1.76t-1.76 4.256h-1.984q-0.832 0-1.44 0.576t-0.576 1.408 0.576 1.44 1.44 0.576h1.984v4h-1.984q-0.832 0-1.44 0.576t-0.576 1.408 0.576 1.44 1.44 0.576h1.984v4h-1.984q-0.832 0-1.44 0.576t-0.576 1.408zM10.016 24h2.080q0-0.064-0.032-0.416t-0.064-0.576 0.064-0.544 0.032-0.448h-2.080v1.984zM10.016 20h2.464q0.288-1.088 0.768-1.984h-3.232v1.984zM10.016 16h4.576q0.992-1.216 2.112-1.984h-6.688v1.984zM10.016 12h16v-1.984h-16v1.984zM10.016 8h16v-1.984h-16v1.984zM14.016 23.008q0 1.824 0.704 3.488t1.92 2.88 2.88 1.92 3.488 0.704 3.488-0.704 2.88-1.92 1.92-2.88 0.704-3.488-0.704-3.488-1.92-2.88-2.88-1.92-3.488-0.704-3.488 0.704-2.88 1.92-1.92 2.88-0.704 3.488zM18.016 23.008q0-2.080 1.44-3.52t3.552-1.472 3.52 1.472 1.472 3.52q0 2.080-1.472 3.52t-3.52 1.472-3.552-1.472-1.44-3.52zM22.016 23.008q0 0.416 0.288 0.704t0.704 0.288h1.984q0.416 0 0.704-0.288t0.32-0.704-0.32-0.704-0.704-0.288h-0.992v-0.992q0-0.416-0.288-0.704t-0.704-0.32-0.704 0.32-0.288 0.704v1.984z" />
    </svg>

    ,
    path: AUDIT_LOGS,
    permission: { module: "audit_logs", action: "view" },
  },
]

export default moduleConfig;